import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { Lighting } from './../../api/models/lighting.model';
import { DeviceGroup } from './../../api/models/device-group.model';
import { Theme } from './../../api/models/theme.model';
import { ToroLocationApanSetup } from './../../api/models/toro-location-apan-setup.model';
import { ScheduleSummary } from './../../api/models/schedule-summary.model';
import { SceneState } from './scenes/scene.entity';
import { ThemeState } from './themes/theme.entity';
import { SceneScheduleSummaryState } from './scene-schedule-summary/scene-schedule-summary.entity';
import { ThemeScheduleSummaryState } from './theme-schedule-summary/theme-schedule-summary.entity';
import { RGBColorState } from './rgb-color/rgb-color.entity';
import { CCTColorState } from './cct-color/cct-color.entity';
import { ThemesStatusState } from './themes-status/themes-status.entity';
import { ScenesStatusState } from './scenes-status/scenes-status.entity';

export const lightingAdapter: EntityAdapter<Lighting> = createEntityAdapter<Lighting>();

export interface LightingState extends EntityState<Lighting> {
    scenes: SceneState;
    themes: ThemeState;
    scenesStatus: ScenesStatusState;
    themesStatus: ThemesStatusState;
    rgbColors: RGBColorState;
    cctColors: CCTColorState;
    sceneScheduleSummaryList: SceneScheduleSummaryState;
    themeScheduleSummaryList: ThemeScheduleSummaryState;
    ids: number[];
    entities: any;
}
